import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HotelService } from '../services/hotel.service';
import { Hotel } from '../hotel';

import { MessageService } from '../services/message.service';
@Component({
  selector: 'app-paybill',
  templateUrl: './paybill.component.html',
  styleUrls: ['./paybill.component.css']
})
export class PaybillComponent implements OnInit {

  constructor(private router: Router,private hotelService : HotelService, private messageService : MessageService, private activatedroute : ActivatedRoute) { }
  bill_no : any;
  ngOnInit() {
    this.bill_no = this.activatedroute.snapshot.params['id'];
    this.getPayBills(this.bill_no);
  }
  model = new Hotel;
  rates:any;
  obj:any;
  getPayBills(bill_no)
  {
    this.obj = { "bill_no":bill_no};
    this.hotelService
        .getpayBill(this.obj)
        .subscribe( rates => {
          this.rates = rates[0];
          Object.assign(this.model, this.rates);
         
         if(this.model.pending_amount == 0)
         {
          this.messageService.showMessage('div#msg','alert-info',"you dont have any pending amount",'glyphicon-ok')
          this.router.navigate(['report']);
          }
        })
  }
  payBill()
  {
    this.hotelService
    .addpayBill(this.model)
    .subscribe( response => {
      this.getPayBills(this.bill_no);
      $('#myform').trigger("reset");
      this.messageService.showMessage('div#msg','alert-'+response.bg,response.response,'glyphicon-'+response.icon)
    })
  }


}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/paybill/paybill.component.ts